// Blizzard realm slugs drop apostrophes and accents and join the rest with dashes, so
// `Kil'jaeden` is `kiljaeden` and `Área 52` is `area-52`. Raider.io returns the display name, and
// every external character link has to be built from it.
// Kept in sync with `normalizeArmoryRealm` in src/services/cloudFlareWorker.js.
export function normalizeRealmSlug(value) {
  return String(value || '')
    .normalize('NFD')
    .replace(/\p{M}/gu, '')
    .toLowerCase()
    .replace(/['’.]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
}

export function normalizeCharacterName(value) {
  return String(value || '').trim().toLowerCase()
}

export function normalizeRegion(value) {
  return String(value || '').trim().toLowerCase()
}

// Returns the raw slug parts. Callers that build a URL string encode them with `encodedCharacterPath`.
export function characterPath(profile = {}) {
  return {
    region: normalizeRegion(profile.region),
    realm: normalizeRealmSlug(profile.realm),
    name: normalizeCharacterName(profile.name),
  }
}

export function encodedCharacterPath(profile = {}) {
  const path = characterPath(profile)
  return {
    region: encodeURIComponent(path.region),
    realm: encodeURIComponent(path.realm),
    name: encodeURIComponent(path.name),
  }
}
